import { IconWrapper, CircleIconWrapper } from './IconWrapper.tsx';
import type { ComponentType, JSX, ReactNode } from 'react';
import type { IconWrapperProps, IconProps } from '@federa/types/ui-icons';

function createIconFactory(Wrapper: ComponentType<IconWrapperProps>) {
	return function (name: string, children: ReactNode) {
		function Icon(props: IconProps) {
			return <Wrapper {...props}>{children}</Wrapper>;
		}

		Icon.displayName = name;

		return Icon;
	};
}

/** What every icon factory hands back: a component taking the shared icon props. Named so the two factories below
 *  cannot drift from each other or from `IconProps`. */
type IconComponent = (props: IconProps) => JSX.Element;

/** Creates an icon component from SVG children, using the standard IconWrapper. */
export function createIcon(name: string, children: ReactNode): IconComponent {
	return createIconFactory(IconWrapper)(name, children);
}

export function createCircleIcon(name: string, children: ReactNode): IconComponent {
	return createIconFactory(CircleIconWrapper)(name, children);
}
